import type { Theme } from '@mui/material/styles';
import { EvacZoneStatus, RegionEvacZoneStyle } from 'shared/types';
import {
  EVAC_ZONE_LAYER_COLORS,
  EVAC_ZONE_NORMAL_COLOR,
} from '../../../constants';

export type EvacZoneStatusChipStyle = {
  backgroundColor: string;
  color: string;
  /** Small indicator dot (map / select menu). */
  indicatorColor: string;
};

/** Chip / tag colors for evac zone status in tables and selects. */
export const getEvacZoneStatusChipStyles = (
  theme: Theme,
  evacZoneStyle: RegionEvacZoneStyle,
  status?: EvacZoneStatus,
): EvacZoneStatusChipStyle => {
  const backgroundColor = status
    ? EVAC_ZONE_LAYER_COLORS[evacZoneStyle][status]
    : EVAC_ZONE_NORMAL_COLOR;

  return {
    backgroundColor,
    color: theme.palette.getContrastText(backgroundColor),
    indicatorColor: backgroundColor,
  };
};
